import { COLORS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');
  // const minMd = theme.breakpoints.up('md');
  // const minLg = theme.breakpoints.up('lg');
  // const minXl = theme.breakpoints.up('xl');

  return {
    root: {
      paddingBottom: 40,
      backgroundColor: COLORS.WHITE_DARK,
      [minSm]: {
        paddingBottom: 0,
      },
    },
    innerWrapper: {
      margin: '0 auto',
      [minSm]: {
        padding: '40px 30px',
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 1200,
      },
    },
    tableWrapper: {
      [minSm]: {
        width: '100%',
      },
    },
    tableTitle: {
      flex: '1',
    },
    tableHeaderWrapper: {
      display: 'none',
      [minSm]: {
        display: 'flex',
        paddingBottom: '24px',
      },
    },
    tableHeaderButton: {
      textTransform: 'none',
      fontWeight: 'normal',
      backgroundColor: '#009a44',
      color: COLORS.WHITE,
    },
    leftIcon: {
      marginRight: '10px',
    },
    loadingWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 100,
    },
    status1: {
      color: COLORS.BLUE_LIGHT,
    },
    status2: {
      color: COLORS.YELLOW_DARK,
    },
    status3: {
      color: COLORS.GREEN,
    },
    phoneLink: {
      color: COLORS.BLUE_DARK,
      fontWeight: 'normal',
      textDecoration: 'underline',
    },
    phoneNotProvided: {
      color: COLORS.GREY_DARK,
    },
  };
};

export default styles;
